export const VIP_SUBSCRIPTION_SLUG = "vip";
